export const CREATE_CUSTOM_FORM_REQUEST = "CREATE_CUSTOM_FORM_REQUEST";
export const CREATE_CUSTOM_FORM_SUCCESS = "CREATE_CUSTOM_FORM_SUCCESS";
export const CREATE_CUSTOM_FORM_FAILURE = "CREATE_CUSTOM_FORM_FAILURE";
export const CREATE_CLONE_CUSTOM_FORM_SUCCESS = "CREATE_CLONE_CUSTOM_FORM_SUCCESS"

export const SUBMIT_CUSTOM_FORM_REQUEST = "SUBMIT_CUSTOM_FORM_REQUEST";
export const SUBMIT_CUSTOM_FORM_SUCCESS = "SUBMIT_CUSTOM_FORM_SUCCESS";
export const SUBMIT_CUSTOM_FORM_FAILURE = "SUBMIT_CUSTOM_FORM_FAILURE";
export const SHOW_FIRST_CUSTOM_FORM = "SHOW_FIRST_CUSTOM_FORM"